import { Box, Divider, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import AccordionMenu from './AccordionMenu';
import { GlobalContext } from '../context/GlobalState';
import { strings } from 'localisation';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';

// GOTOBED PRODUCT FILTERS
// Desktop only: a borderless, sticky sidebar of category filters. On mobile the same AccordionMenu
// is already reachable from the header's hamburger menu, so nothing is rendered here.
export default function ProductFilters() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const { lang, menu, setMenu } = useContext(GlobalContext);

  useEffect(async () => {
    if (!menu) {
      const { data } = await axios.get(`/menu`);
      setMenu(data);
    }
  }, []);

  if (!isDesktop) return null;

  return (
    <Box sx={{ position: 'sticky', top: 24, pr: 2, minWidth: 240, maxWidth: 320 }}>
      <Typography variant="overline" sx={{ display: 'block', color: 'gold.text' }}>
        {strings[lang]?.productCategories || 'Категории'}
      </Typography>
      <Divider sx={{ mt: 1.5, mb: 2, borderColor: 'divider' }} />
      {menu && <AccordionMenu categoryList={menu} />}
    </Box>
  );
}
